import axios from 'axios';

// Pre vendita → Controllo catalogo: prodotti attivi con dati mancanti o sbagliati
const state = {
	items: [],
	info: { counts: {}, withIssues: 0, scanned: 0, generated_at: null },
};

const getters = {
	getItems: state => state.items,
	getInfo: state => state.info,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });

const actions = {
	// `fresh`: rifa' il controllo invece di usare quello degli ultimi 10 minuti
	asyncFetchData: async (context, { settings, fresh = false }) => {
		const { page, itemsPerPage } = settings.options;
		const filters = settings.filters || {};
		const res = await axios.post(
			`${context.rootGetters['settings/getUrl']}catalogcheck`,
			{ data: { page, itemsPerPage, search: settings.search, issue: filters.issue || '', fresh } },
			auth(context),
		);
		context.commit('setItems', res.data.data);
		context.commit('setInfo', { counts: res.data.counts, withIssues: res.data.withIssues, scanned: res.data.scanned, generated_at: res.data.generated_at });
		return res.data.pagination;
	},
	destroyData: context => {
		context.commit('setItems', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setInfo: (state, value) => {
		state.info = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
